import { generatePath } from 'react-router-dom';

import { InstructorTab, StudentTab } from '../views/School/V2/types';

export const ACADEMIC_TAB_KEY = 'cstab';

export const getAcademicMainUrl = (
  courseSectionId: number | undefined,
  tab?: StudentTab | InstructorTab
) => {
  const basePath = generatePath('/school/courseSections/:courseSectionId', {
    courseSectionId: courseSectionId?.toString() ?? '',
  });

  if (tab) {
    const searchParams = new URLSearchParams();
    searchParams.set(ACADEMIC_TAB_KEY, tab);
    return `${basePath}?${searchParams.toString()}`;
  }

  return basePath;
};

export const getEnrollmentAssignmentsUrl = (
  courseSectionId: number | undefined,
  enrollmentId: number | undefined
) =>
  generatePath('/school/courseSections/:courseSectionId/enrollment/:enrollmentId/assignments', {
    courseSectionId: courseSectionId?.toString() ?? '',
    enrollmentId: enrollmentId?.toString() ?? '',
  });

export const getAssignmentConfigurationUrl = (
  courseSectionId: number | undefined,
  assignmentId: number | undefined
) =>
  generatePath('/school/courseSections/:courseSectionId/assignments/:assignmentId', {
    courseSectionId: courseSectionId?.toString() ?? '',
    assignmentId: assignmentId?.toString() ?? '',
  });

export const getDiscussionAttemptsViewUrl = (
  courseSectionId: number | undefined,
  assignmentId: number | undefined,
  attemptId?: number | undefined
) =>
  generatePath(
    '/school/courseSections/:courseSectionId/assignments/:assignmentId/responses/:attemptId',
    {
      courseSectionId: courseSectionId?.toString() ?? '',
      assignmentId: assignmentId?.toString() ?? '',
      attemptId: attemptId?.toString() ?? '',
    }
  );

export const getSignInRedirectUrl = () => {
  if (window.location.pathname.includes('from')) {
    return `/signIn`;
  } else {
    return `/signIn?from=${encodeURIComponent(window.location.pathname + window.location.search)}`;
  }
};
